import { useState } from 'react';
import SectionHeading from '@/components/base/SectionHeading';
import { platformFaqs } from '@/mocks/mt4mt5Page';

export default function PlatformFaq() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20 lg:px-10">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[360px_1fr] lg:gap-12">
          <div className="self-start lg:sticky lg:top-24">
            <SectionHeading
              eyebrow="คำถามที่พบบ่อย"
              title="คำถามที่พบบ่อยเกี่ยวกับ MT4 และ MT5"
              subtitle="รวมข้อสงสัยตอนติดตั้งและเปิดกราฟครั้งแรก ไปจนถึงเรื่องที่มือใหม่มักสะดุด เช่น เวลาแพลตฟอร์มที่ไม่ตรงกับไทย ขนาด Lot และการติดตั้งบนมือถือ"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-100/60 px-4 py-3.5">
              <p className="flex items-start gap-2 text-xs leading-relaxed text-foreground-600">
                <i className="ri-lightbulb-line mt-0.5 shrink-0 text-base text-accent-600" />
                หกข้อสุดท้ายคือเรื่องที่มือใหม่มักสะดุดก่อนเริ่มใช้จริง ถ้าต้องการภาพรวมแบบเร็ว ๆ
                ดูสรุปได้ที่หัวข้อ <a href="#essentials" className="cursor-pointer font-medium text-primary-700 hover:text-primary-600">มือใหม่ควรรู้</a> ด้านบน
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {platformFaqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={faq.q}
                  className={`overflow-hidden rounded-lg border bg-background-50 transition-colors ${
                    isOpen ? 'border-primary-300' : 'border-background-200 hover:border-background-300'
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? -1 : index)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                  >
                    <span className="flex items-start gap-3">
                      <span
                        className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-num text-[10px] font-semibold ${
                          isOpen ? 'bg-primary-500 text-background-50' : 'bg-primary-100 text-primary-700'
                        }`}
                      >
                        {String(index + 1).padStart(2, '0')}
                      </span>
                      <span className="text-sm font-semibold leading-snug text-foreground-900 md:text-[15px]">
                        {faq.q}
                      </span>
                    </span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? 'bg-primary-100 text-primary-700' : 'bg-background-100 text-foreground-500'
                      }`}
                    >
                      <i className={`ri-${isOpen ? 'subtract' : 'add'}-line text-base`} />
                    </span>
                  </button>

                  <div
                    className={`grid transition-all duration-300 ease-out ${
                      isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
                    }`}
                  >
                    <div className="overflow-hidden">
                      <div className="flex flex-col gap-2.5 px-4 pb-4 pl-[3.25rem] md:px-5 md:pl-[3.75rem]">
                        <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                        {faq.a2 ? (
                          <p className="text-sm leading-relaxed text-foreground-600">{faq.a2}</p>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}